import { styled } from '@mui/material';

export const StyledStepperHeaderWrapper = styled('div')({
  marginBottom: '1rem'
});
